export const Routes = {
  // pages
  DashboardOverview: { path: "/dashboard/overview" },
  Transactions: { path: "/transactions" },
  Settings: { path: "/settings" },
  BootstrapTables: { path: "/tables/bootstrap-tables" },
  Billing: { path: "/examples/billing" },
  Invoice: { path: "/examples/invoice" },
  Lock: { path: "/examples/lock" },

  // new pages
  Home: { path: "/home" },
  Signin: { path: "/sign-in" },
  Signup: { path: "/sign-up" },
  Confirm: { path: "/confirm" },
  ForgotId: { path: "/forgot-id" },
  ForgotPassword: { path: "/forgot-password" },
  ResetPassword: { path: "/reset-password" },
  EditProfile: { path: "/edit-profile" },
  NotFound: { path: "/404" },
  ServerError: { path: "/500" },
  Matching: { path: "/matching" },
  Attention: { path: "/attention" },
  CompInfo: { path: "/CompInfo" },
  AttentionsInfo: { path: "/AttentionsInfo" },
  MatchingInfo: { path: "/MatchingInfo" },
  Industry: { path: "/Industry" },
  Admin: { path: "/admin" },
  UserManage: { path: "/admin/user-manage" },
  MatManage: { path: "/admin/MatManage" },
  CompManage: { path: "/admin/company-manage" },
  Front: { path: "/front" },
  Defalut: { path: "/" },
  SearchResult: { path: "/search-result" },
};
